import { render } from "./CreatePaymentLiquidation3.vue?vue&type=template&id=3890f9ab"
import script from "./CreatePaymentLiquidation3.vue?vue&type=script&lang=js"
export * from "./CreatePaymentLiquidation3.vue?vue&type=script&lang=js"

import "./CreatePaymentLiquidation3.vue?vue&type=style&index=0&id=3890f9ab&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__